import React from "react";
import { QrCode, UserPlus, ShieldCheck, ArrowRight } from "lucide-react";
import { t } from "../../i18n/translations";

const steps = [
  {
    icon: QrCode,
    color: "bg-red-50 text-red-600 border-red-100",
    number: "01",
    titleKey: "howItWorks.step1Title",
    descKey: "howItWorks.step1Desc",
    ctaKey: "howItWorks.step1Cta",
  },
  {
    icon: UserPlus,
    color: "bg-teal-50 text-teal-600 border-teal-100",
    number: "02",
    titleKey: "howItWorks.step2Title",
    descKey: "howItWorks.step2Desc",
    ctaKey: "howItWorks.step2Cta",
  },
  {
    icon: ShieldCheck,
    color: "bg-emerald-50 text-emerald-600 border-emerald-100",
    number: "03",
    titleKey: "howItWorks.step3Title",
    descKey: "howItWorks.step3Desc",
    ctaKey: "howItWorks.step3Cta",
  },
];

const HowItWorksNew = () => {
  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-slate-600 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-4 border border-slate-200 shadow-sm">
            {t("howItWorks.badge")}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            {t("howItWorks.title")}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">{t("howItWorks.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((step, idx) => {
            const Icon = step.icon;
            return (
              <div
                key={idx}
                className="group bg-white rounded-lg p-8 border border-slate-200 hover:border-slate-300 hover:shadow-md transition-colors duration-150"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className={`w-14 h-14 rounded-lg flex items-center justify-center border ${step.color}`}>
                    <Icon size={24} />
                  </div>
                  <span className="text-4xl font-extrabold text-slate-200 group-hover:text-slate-300 transition-colors">
                    {step.number}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-slate-900 mb-3">{t(step.titleKey)}</h3>
                <p className="text-slate-600 leading-relaxed mb-6">{t(step.descKey)}</p>

                <button className="inline-flex items-center gap-1.5 text-sm font-semibold text-red-600 hover:text-red-700 group-hover:gap-2.5 transition-colors duration-150">
                  {t(step.ctaKey)}
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksNew;
